<template lang="pug">
  .flex.flex-col.mt-48.w-264
    .flex.h-80.justify-start.items-start.leftEachCol(v-for="(e,index) in sideOptions" 
    :class="{'items-center': alignMenu(index), 'hover:bg-grey-ED': !e.disabled, 'bg-grey-ED': active === index && !e.disabled ,'cursor-pointer': !e.disabled, 'text-grey-9E': e.disabled}" 
    @click="goMenu(e)")
      .min-w-4.w-4.h-full( :class="{'bg-main-0': active === index && !e.disabled}" )
      //v-if='active === i && !e.disabled'
      iCon.max-h-28.max-w-28.mx-28(:iconClass="e.icon" type="svg" )
      .text-left.text-20.leading-30.pt-3(ref="subMenu"  ) {{e.name}}  
</template>


<script>
export default {
  name: 'SideMenuBlock',
  props: {
    sideOptions: {
      type: Array,
      required: true,
    },
    active:  {
      type: Number,
      default: 0,
      required: false,
    },
    activeRoute:  {
      type: String,
      required: false,
    },
  },
  data() {
    return {
    };
  },
  async mounted(){
        this.alignMenu()
  },
  methods: {
    goMenu(e){
      if(e.disabled) return
      this.$router.push({ path: `/`,  name: e.val}).catch(err => err);
    },
    alignMenu(i){
      if( i == undefined ) return
      this.$nextTick(function () {
        let menuItem = this.$refs.subMenu[i]
        menuItem.clientHeight > 35 ? menuItem.parentNode.classList.remove('items-center') : menuItem.parentNode.classList.add('items-center')
        menuItem.clientHeight > 35 ? menuItem.previousElementSibling.classList.add('mt-14') : menuItem.previousElementSibling.classList.remove('mt-14')
        menuItem.clientHeight > 35 ? menuItem.classList.add('mt-10') : menuItem.classList.remove('mt-10')
        return menuItem.clientHeight > 35 ? true : true
      })
    }
  },
  computed: {
    radioValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('changeValue', val);
        //emit('update:active', val)
      }
    }
  },
  watch : {
    '$store.state.user.langIsSelected': function() {
      // this.alignMenu()
    },
  }
};
</script>

<style lang="scss" scoped>



</style>
